// import helper from '@/_libs/helper';

import user from './_user';
import pendingApproval from './_pending-approval';
import permissions from './_permissions';
import sellerRecords from './_seller-records';
import report from './_report';

const ADMIN_API = {
  user,
  pendingApproval,
  permissions,
  sellerRecords,
  report,
};

export default {
  // ...helper,
  ...ADMIN_API,
};
